import { useState, useEffect, useContext, useMemo } from "react";
import { Auth } from "aws-amplify";
import { logError } from "util/logging";
import { LoggedInUserContext } from "contexts/LoggedInUser";
import { getAvailableRoles, highestUserRole } from "util/role";

/**
 * Contains the logic for Header
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */

const useHeader = () => {
  const [userName, setUserName] = useState("");
  const { loggedInUserProfile } = useContext(LoggedInUserContext);

  useEffect(() => {
    authenticate(setUserName);
  }, []);

  const availableRoles = useMemo(() => {
    if (!loggedInUserProfile?.accounts?.length) {
      return [];
    }
    return getAvailableRoles(highestUserRole(loggedInUserProfile.accounts.map(account => account.role)));
  }, [loggedInUserProfile]);

  const signOut = () => {
    handleSignOut();
  };

  return { userName, signOut, availableRoles };
};

const handleSignOut = async () => {
    try {
        await Auth.signOut({ global: true });
        window.location.href = "/";
    } catch (error) {
        console.log('error signing out: ', error);
    }
};

const authenticate = setUserName => {
  Auth.currentAuthenticatedUser()
    .then(user => {
      setUserName(user.attributes.name || user.attributes.email);
    })
    .catch(e => {
      logError("HeaderView error", e);
      setUserName("");
    });
};

export default useHeader;
